import { toast } from "react-toastify"
import React, { useEffect, useState } from "react"

import { IDAM } from "../../../api/Registry"
import { APPLICATION } from "../../../utils/Constants"
import { RouteHydration } from "../../../utils/Helpers"
import HttpServices from "../../../services/HttpServices"
import { AttributeIdentity } from "../stages/AttributeIdentity"
import { DynamicModal } from "../../../lib/fragments/DynamicModal"
import { G_onInputBlurHandler, G_onInputChangeHandler } from "../../../components/utils/InputHandlers"

export const AttributeDialog = ({ show, showOrHide, onComplete, payload, dataDump }) => {
    const [state, setstate] = useState({
        payload: null,
        posting: false,
        httpStatus: 200,
        status: 'pending',
        data: {
            groups: null
        },
        input: {
            // Attribute Identity
            name: '',
            attr_group: null,
            hint: '',

            configuration: '',
            format: null,
            mandatory: false,
            minimum: '',
            maximum: '',
            unit_label: '',
            multiline: false,
            whole_numbers: false,
            allow_negative: false,
            allow_special: false,
            allow_mulitple: false,
            display_style: {
                key: "radio",
                label: "Radio Buttons",
            },
            text_case: {
                key: "mixed",
                label: "Mixed Case",
            },

            oversight: '',
            ownership: false,
            coowners: false,
            restricted: false,
            editable: false,
        },
        errors: {
            // Attribute Identity
            basic: '',
            name: '',
            attr_group: '',
            hint: '',

            // Attribute Configuration
            configuration: '',
            format: '',
            minimum: '',
            maximum: '',
            unit_label: '',
            display_style: '',

            // Oversight
            oversight: '',
        }
    })

    const [substate, setsubstate] = useState({
        title: '',
        action: 'Update'
    })

    const minLength = 3;
    const maxLength = 200;

    const formSections: Record<string, string[]> = {
        'basic': ["attr_group", "name", "hint"],
        'configuration': ["format", "display_style", "minimum", "maximum", "unit_label"],
    }

    useEffect(() => {
        if (show) {
            dialogFlowSwitch()
        }
    }, [show])

    const onCloseModal = async () => {
        showOrHide()

        // Reset the state on close
        setTimeout(() => {
            setstate((prev: any) => ({
                ...prev,
                posting: false,
                httpStatus: 200,
                status: 'pending',
                data: {
                    group: null
                },
                input: {
                    ...prev.input,
                    group_label: '',
                    add_another: '',
                    hint: '',
                },
                errors: {
                    ...prev.errors,
                    group_label: '',
                    hint: '',
                }
            }))

            setsubstate((prev: any) => ({
                ...prev,
                title: '',
                action: 'Update'
            }))
        }, 300)
    }

    const dialogFlowSwitch = async () => {
        switch (payload?.action) {
            case 'attribute.amend':
                setsubstate((prev: any) => ({
                    ...prev,
                    // title: 'Edit Attribute Details',
                    action: 'Update'
                }))

                getAttributeGroups()
                break;

            default:
                break;

        }
    }

    const canvasHandler = (action: any) => {
        switch (action) {
            case 'attribute.amend':
                return <AttributeIdentity
                    state={state}
                    setstate={setstate}
                    blurHandler={onInputBlur}
                    changeHandler={onChangeHandler}
                    listboxHandler={onListBoxHandler}
                />
        }
    }

    const getAttributeGroups = async () => {
        let { data, httpStatus, status, input } = state

        try {
            const response: any = await HttpServices.httpGet(IDAM.ATTR_GROUPS)
            httpStatus = response.status

            if (httpStatus === 200) {
                const payloadR: any = response.data.payload
                data.groups = payloadR.groups

                input.name = dataDump.attr.s?.e
                input.hint = dataDump.attr.s?.t
                input.attr_group = {
                    g: dataDump.attr.g,
                    e: dataDump.attr.e,
                    t: dataDump.attr.t
                }

                status = 'fulfilled'
            } else {
                status = 'rejected'
            }
        } catch (error) {
            status = 'rejected'
            httpStatus = 500

            console.log(payload);
            console.log(error);

        }

        setstate((prev: any) => ({
            ...prev,
            data,
            input,
            status,
            httpStatus,
            payload: payload,
        }))
    }

    const onChangeHandler = (e: any) => {
        let { posting, input, errors } = state
        if (posting) return

        let output: any = G_onInputChangeHandler(e)

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const targetLength = (name: string) => {
        switch (name) {
            case 'unit_label':
                return {
                    min: 1,
                    max: 30
                };

            default:
                return {
                    min: 3,
                    max: 30
                };
        }
    }

    const onInputBlur = (e: any) => {
        let { posting, input, errors } = state
        if (posting) return

        const target0 = targetLength(e.target.name)
        const title = e.target.name === 'name' ? 'Attribute name' : ''

        let output: any = G_onInputBlurHandler(e, title, target0.min, target0.max)

        let updatedInput = {
            ...input,
        }

        let updatedErrors = {
            ...errors,
        };

        switch (e.target.name) {
            case 'minimum':
            case 'maximum':
                const format = input.format?.key

                if (!["freetext"].includes(format)) {
                    // TODO: Add validation for non-numeric and non-freetext
                    return
                }

                const targetName = e.target.name
                const targetValue = e.target.value

                if (format === 'freetext') {
                    const num = Number(targetValue);
                    const isWholeNumber = Number.isInteger(num);

                    if (!isWholeNumber) {
                        output.error = "Length must be a whole number."
                    } else {
                        // Remove the error message from blur handler
                        output.error = ''

                        if (targetName === "minimum") {
                            const newMin = num < minLength ? minLength
                                : num > maxLength ? maxLength
                                    : num

                            updatedInput = {
                                ...updatedInput,
                                minimum: newMin.toString(),
                                maximum:
                                    input.maximum && Number(input.maximum) < newMin
                                        ? ""
                                        : input.maximum,
                            };
                        }

                        if (targetName === "maximum") {
                            const newMax = num < minLength ? minLength
                                : num > maxLength ? maxLength
                                    : num

                            updatedInput = {
                                ...updatedInput,
                                maximum: newMax.toString(),
                                minimum:
                                    input.minimum && Number(input.minimum) > newMax
                                        ? minLength.toString()
                                        : input.minimum,
                            };
                        }
                    }
                } else if (format === 'numeric') {
                    const num = Number(targetValue);

                    // Whole number check
                    if (input.whole_numbers && !Number.isInteger(num)) {
                        output.error = "Value must be a whole number.";
                    } else if (!input.allow_negative && num < 0) {
                        // Negative number check
                        output.error = "Negative numbers are not allowed.";
                    } else {
                        // Clear error if passed checks
                        output.error = "";

                        // Update fields
                        if (targetName === "minimum") {
                            updatedInput = {
                                ...updatedInput,
                                minimum: num.toString(),
                                maximum:
                                    input.maximum && Number(input.maximum) < num
                                        ? "" // reset maximum if smaller than minimum
                                        : input.maximum,
                            };
                        }

                        if (targetName === "maximum") {
                            updatedInput = {
                                ...updatedInput,
                                maximum: num.toString(),
                                minimum:
                                    input.minimum && Number(input.minimum) > num
                                        ? "" // reset minimum if greater than maximum
                                        : input.minimum,
                            };
                        }
                    }

                }
                break;

            default:
                updatedInput = {
                    ...updatedInput,
                    [e.target.name]: output.value
                }
                break;
        }

        const sectionWithError = findSection(e.target.name)
        const stillHasErrors = sectionHasErrors(sectionWithError, errors)

        updatedErrors = {
            ...updatedErrors,
            [e.target.name]: output.error,
            [sectionWithError]: stillHasErrors ? updatedErrors[sectionWithError] : ''
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const onListBoxHandler = (e: any, list: any) => {
        let { posting, data, errors, input } = state
        if (posting) return

        let updatedErrors = {
            ...errors
        }

        switch (list) {
            case 'attr_group':
                const attrGroup = data.groups.find(
                    (grp: any) => grp.g === e
                )

                updatedErrors = {
                    ...updatedErrors,
                    attr_group: '',
                }

                setstate((prev: any) => ({
                    ...prev,
                    input: {
                        ...prev.input,
                        attr_group: attrGroup,
                    },
                    errors: updatedErrors
                }));
                break

            case 'format':
                const isSameFormat = input.format?.key === e.key;
                const isFreeText = e.key === 'freetext';
                const isPredefined = e.key === 'predefined';

                // Pre-calculate new values
                const multiline = isFreeText ? input.multiline : false;
                const displayStyle = isPredefined ? input.display_style : { key: "radio", label: "Radio Buttons" };
                const textCase = isFreeText
                    ? input.text_case
                    : { key: 'mixed', label: 'Mixed Case' };

                const minimum = isSameFormat ? input.minimum : '';
                const maximum = isSameFormat ? input.maximum : '';

                // Reset errors if format changes
                if (!isSameFormat) {
                    updatedErrors = {
                        ...updatedErrors,
                        format: '',
                        minimum: '',
                        maximum: '',
                        unit_label: '',
                        display_style: '',
                    }
                }

                setstate((prev: any) => ({
                    ...prev,
                    input: {
                        ...prev.input,
                        format: e,
                        minimum,
                        maximum,
                        multiline,
                        display_style: displayStyle,
                        whole_numbers: false,
                        allow_negative: false,
                        allow_special: false,
                        text_case: textCase,
                    },
                    show: {
                        ...prev.show,
                        lengthVisibility: isSameFormat ? show.lengthVisibility : false,
                        rangeVisibility: isSameFormat ? show.rangeVisibility : false,
                    },
                    errors: updatedErrors,
                }))
                break

            case 'display_style':
                if (input.format?.key !== 'predefined') {
                    setstate((prev: any) => ({
                        ...prev,
                        input: {
                            ...prev.input,
                            display_style: { key: "radio", label: "Radio Buttons" },
                        },
                        errors: updatedErrors
                    }));
                } else {
                    updatedErrors = {
                        ...updatedErrors,
                        display_style: '',
                    }

                    setstate((prev: any) => ({
                        ...prev,
                        input: {
                            ...prev.input,
                            display_style: e,
                            allow_mulitple: e?.key !== 'dropdown' ? false : input.allow_mulitple,
                        },
                        errors: updatedErrors
                    }));
                }
                break;

            case 'text_case':
                if (input.format?.key !== 'freetext') {
                    setstate((prev: any) => ({
                        ...prev,
                        input: {
                            ...prev.input,
                            text_case: {
                                key: "mixed",
                                label: "Mixed Case",
                            },
                        },
                        errors: updatedErrors
                    }));
                } else {
                    setstate((prev: any) => ({
                        ...prev,
                        input: {
                            ...prev.input,
                            text_case: e,
                        },
                        errors: updatedErrors
                    }));
                }
                break
        }

        const sectionWithError = findSection(list)
        const stillHasErrors = sectionHasErrors(sectionWithError, updatedErrors)

        updatedErrors = {
            ...updatedErrors,
            [sectionWithError]: stillHasErrors ? updatedErrors[sectionWithError] : '',
        }

        setstate((prev: any) => ({
            ...prev,
            errors: updatedErrors,
        }))
    }

    const findSection = (fieldName: string) => {
        // Find section in which input belongs
        for (const [section, fields] of Object.entries(formSections)) {
            if (fields.includes(fieldName)) {
                return section;
            }
        }
        return null;
    }

    const sectionHasErrors = (section: string, errors: Record<string, string>) => {
        const fields = formSections[section] || [];
        // If any field still has an error
        return fields.some((field) => errors[field]);
    }

    const dialogFormHandler = (e: any) => {
        e.preventDefault()
        let { posting, input } = state
        if (posting) return

        let valid = true
        let inputKeys = null
        let errorKeys = null

        switch (payload?.action) {
            case 'attribute.amend':
                if (!input.attr_group) {
                    setstate((prev: any) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            attr_group: 'Kindly select an attribute group',
                            basic: 'Kindly clear errors in section before proceeding',
                        },
                    }));

                    return
                }

                inputKeys = [
                    'name',
                    'hint',
                ]

                inputKeys.forEach((inputKey: any) => {
                    try {
                        let oTarget = e.target[inputKey]

                        let event: any = {
                            target: {
                                name: oTarget.name,
                                required: oTarget.required,
                                value: oTarget.value.trim(),
                            }
                        }

                        onInputBlur(event)
                    } catch (error) {
                        // console.log(error);
                        // Override error
                    }
                })

                let { errors } = state

                errorKeys = [
                    'name', 'hint'
                ]

                errorKeys.forEach((errorObject: any) => {
                    if (errors[errorObject].length > 0) {
                        valid = false
                    }
                })

                if (valid) {
                    amendAttributeIdentity()
                }
                break;
        }
    }

    const amendAttributeIdentity = async () => {
        let { input } = state

        try {
            let formData = new FormData()
            formData.append('action', 'amend')
            formData.append('hint', input.hint)
            formData.append('label', input.name)
            formData.append('attr_group', input.attr_group?.g)

            const attributePatchRoute = [":attribute"]
                .reduce((route, param, index) =>
                    RouteHydration(route, param, [dataDump.attr.s?.g][index]),
                    IDAM.USR_ATTR_ADDITION
                );

            const response: any = await HttpServices.httpPatch(attributePatchRoute, formData)
            let httpStatus = response.status

            if (httpStatus === 200) {

                onCloseModal()
                onComplete()
            } else {
                if (httpStatus === 422) {
                    // Map of server field names to frontend field names
                    const fieldMapping: Record<string, string> = {
                        label: 'name',
                        case: 'text_case',
                        display: 'display_style',
                    };

                    Object.entries(response.data).forEach(([serverField, errorMessages]) => {
                        const frontendField = fieldMapping[serverField] || serverField; // default to original if no mapping

                        setstate((prev: any) => ({
                            ...prev,
                            errors: {
                                ...prev.errors,
                                [frontendField]: errorMessages
                            }
                        }));
                    });
                } else {
                    toast.error(APPLICATION.ERR_MSG);
                }
            }
        } catch (error) {

        }
    }

    return (
        <React.Fragment>
            <DynamicModal
                size={'md'}
                show={show}
                title={substate.title}
                posting={state.posting}
                status={state.status}
                actionName={substate.action}
                showOrHide={onCloseModal}
                onSubmit={dialogFormHandler}
                content={
                    <>
                        {
                            canvasHandler(payload?.action)
                        }


                    </>
                }
            />
        </React.Fragment>
    )
}